'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _micromodal = require('micromodal');

var _micromodal2 = _interopRequireDefault(_micromodal);

var _utils = require('../helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Create a new modal object.
 * @param {object} config - Settings for modal instance.
 */
/**
 * Component: Modal
 * ------------------------------------------------------------------------------
 * Instantiate Micromodal and configure defaults across modal components.
 * - https://micromodal.now.sh/#configuration
 *
 * @namespace Modal
 */
exports.default = function (selector, config) {

  /**
   * Instance default settings.
   */
  var defaults = {
    disableScroll: false
  };

  /**
   * Instance settings.
   */
  var settings = (0, _utils.extendDefaults)(defaults, config);

  /**
   * Instantiate a new modal.
   */
  function init() {
    _micromodal2.default.init(selector, settings);
  }

  /**
   * Show modal with default settings.
   */
  function show() {
    _micromodal2.default.show(selector, settings);
  }

  /**
   * Close modal with default settings.
   */
  function close() {
    _micromodal2.default.close(selector, settings);
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    init: init,
    show: show,
    close: close
  });
};